import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import "./HowToDialog.css";

const HowToDialog = ({ isOpen, onClose }) => {
  const { userRole } = useAuth();

  // ダイアログ表示時の背景スクロール防止
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('dialog-open');
    } else {
      document.body.classList.remove('dialog-open');
    }

    return () => {
      document.body.classList.remove('dialog-open');
    };
  }, [isOpen]);

  // ユーザーロールに応じた表示内容を生成
  const AppGuidline = () => {
    if (userRole === 'mentor') {
      return (
        <>
          <div className="feature">
          <h4>メール送信時のマナー</h4>
              <p>
                OGがゼミ生からの連絡だと判断できるように、下記のマナーを守るようゼミ生には伝えています。
                <ul className="send-mail-rules">
                  <li>件名に「【就活ゼミ】」を入れる。</li>
                  <li>本文に所属大学と名前を記載する。</li>
                  <li>本文に「就活ゼミのOG Matchingを利用して連絡した」旨を明記する。</li>
                </ul>
                ゼミ生からだと判断できないメールを受信した際には、返信しなくても構いません。
                <br></br>
                ゼミ生を名乗る不審なメールを受信した場合は、問い合わせフォームから運営までお問い合わせください。
              </p>
        </div>
        </>
      );
    } else if (userRole === 'student') {
      return (
        <>
        <div className="feature">
          <h4>メール送信時のマナー</h4>
              <p>
                OGがゼミ生からの連絡だと判断できるように、下記のマナーを守ってください。
                <ul className="send-mail-rules">
                  <li>件名に「【就活ゼミ】」を入れる。</li>
                  <li>本文に所属大学と名前を記載する。</li>
                  <li>本文に「就活ゼミのOG Matchingを利用して連絡した」旨を明記する。</li>
                </ul>
              </p>
        </div>
        </>
      );
    }
    return null;
  };

  if (!isOpen) return null;

  return (
    <div className="howto-overlay">
      <div className="howto-dialog">
        <div className="howto-header">
          <h2>
            <span className="howto-icon">
              <i className="fas fa-info-circle"></i>
            </span>
            利用方法
            {userRole && (
              <span className="user-role-badge">
                {userRole === 'mentor' ? '（OG）' : userRole === 'student' ? '（学生）' : ''}
              </span>
            )}
          </h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="howto-content">

          <div className="howto-section">
            <p>アプリの利用方法について記載します。</p>
          </div>

          <div className="howto-section">
            <h3><i className="fas fa-mobile-alt"></i> 機能一覧</h3>
            <div className="features">
              <div className="feature">
                <h4><i className="fas fa-user"></i> マイプロフィール</h4>
                <p>自分のプロフィールを閲覧・編集できます。</p>
              </div>
              <div className="feature">
                <h4><svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
                </svg> OG一覧</h4>
                <p>
                  {userRole === 'mentor' 
                    ? '他のOGの一覧を閲覧できます。OGの名前をクリックすると詳細を確認できます。'
                    : userRole === 'student' 
                      ? '登録されているOGの一覧を閲覧できます。OGの名前をクリックすると詳細を確認でき、連絡先を入手できます。'
                      : '登録されているOGの一覧を閲覧できます。OGの名前をクリックすると詳細を確認でき、連絡先を入手できます。'
                  }
                </p>
              </div>
              {userRole === 'mentor' && (
                <div className="feature">
                  <h4><svg className="bottom-nav-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>OG招待（OGのみ）</h4>
                  <p>
                  OG登録するためには、管理者また登録済みOGからの招待が必要です。
                  <br></br>
                  OG招待〜OG登録完了の流れは以下の通りです。                 
                  <ul className="invitation-steps">
                    <li>[OG招待]タブにに移動</li>
                    <li>招待したいOGのメールアドレスを入力して[招待メールを送信]をクリック</li>
                    <li>招待されたOGのもとに招待メールが届く（件名：【就活ゼミ】OG Matchingへのご招待）</li>
                    <li>招待を受けたOGは招待メール内のリンクをクリックし、OG登録フォームにアクセス</li>
                    <li>登録内容を入力後、[認証コードを送信]をクリック</li>
                    <li>登録メールアドレス宛に届いた認証コードを登録フォームにて入力し、[確認]をクリック</li>
                    <li>アプリの画面に遷移できたら、アプリへのOG登録が完了</li>
                  </ul>
                  </p>
                </div>
              )}
              <div className="feature">
                <h4><i className="fas fa-question-circle"></i> 運営へのお問い合わせ</h4>
                <p>
                  OG Matchingに関するお問い合わせは、Googleフォームにて受け付けています。
                  <br></br>
                  メニューの「問い合わせ」を選択するとGoogleフォームに遷移しますので、必要事項を入力してお問い合わせください。
                </p>
              </div>
            </div>
          </div>

          <div className="howto-section">
            <h3><i className="fas fa-handshake"></i> コンタクトルール</h3>
            <div className="features">
              
               {AppGuidline()}
             
              <div className="feature" id="caution">
                <h4>注意・禁止事項</h4>
                <p>
                  詳細は利用規約を確認してください。<br></br>
                  メニューの「利用規約」から確認できます。
                </p>
              </div>
            </div>
          </div>

          <div className="howto-section">
            <h3><i className="fas fa-comments"></i> よくある質問</h3>
            <div className="faq">
              <div className="faq-item">
                <h4>Q. プロフィールを変更したい</h4>
                <p>A: 「マイプロフィール」から編集できます。</p>
              </div>
              
              <div className="faq-item">
                <h4>Q. アプリのことで分からないことがある</h4>
                <p>A: メニューの「問い合わせ」からお問い合わせください。</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="howto-footer">
          <button className="howto-close-button" onClick={onClose}>
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowToDialog; 